import React, { createContext, useState, useEffect, ReactNode } from 'react';

interface ContextProps {
  windowWidth: number;
}

export const WindowWidthContext = createContext<ContextProps>({ windowWidth: 0 });

const WindowWidthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <WindowWidthContext.Provider value={{ windowWidth }}>
      {children}
    </WindowWidthContext.Provider>
  );
};

export { WindowWidthProvider };
export type { ContextProps };

